import React, { Component } from 'react';
import { DEVICES_PAGE_TAB, USER_PREFERENCE_SETS, DEFAULT_TAB_FILTER } from 'common/utils/constants';
import { areObjectsEqual, logger } from 'common/utils/helpers';
import { v4 } from 'uuid';
import { FILTER_DEVICE_TYPES, getFilterSetToSave, getParsedFilterSet } from './utils';
import {
  setDropModalOpen,
  updateDevicesPageManageFilterModal,
  updateDevicesPageCreateFilterModal,
  addFilter,
  removeFilter,
  parseAllSearchFilters,
  updateActiveFilterPreference,
  addToastNotification
} from 'redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import FilterSelectionDropdown from './FiltersBarSubComponents/FilterSelectionDropdown/FilterSelectionDropdown';
import FiltersBarNotification from './FiltersBarSubComponents/FiltersBarNotification/FiltersBarNotification';
import FiltersBarUpdateIcon from './FiltersBarSubComponents/FiltersBarUpdateIcon/FiltersBarUpdateIcon';
import FiltersBarFiltersContainer from './FiltersBarSubComponents/FiltersBarFiltersContainer/FiltersBarFiltersContainer';
import FiltersBarSelectedFilter from './FiltersBarSubComponents/FiltersBarSelectedFilter/FiltersBarSelectedFilter';
import './FiltersBar.css';
import { selectUserPreferences } from '../../../redux/selectors';
import {
  memoOnce,
  selectUserPreferenceList,
  selectUserCategoryPreferences,
  patchUserPreference,
  selectUserPreference
} from '../../../redux/UserPreferences';
import ManageFilterSetsModal from '../ManageFilterSetsModal/ManageFilterSetsModal';
import CreateFilterSetModal from '../ManageFilterSetsModal/CreateFilterSetModal';

const mapDispatchToProps = {
  setDropModalOpen,
  updateDevicesPageManageFilterModal,
  updateDevicesPageCreateFilterModal,
  addFilter,
  removeFilter,
  parseAllSearchFilters,
  updateActiveFilterPreference,
  addToastNotification,
  patchUserPreference
};

class FiltersBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      from: null,
      to: null,
      resetConnectionFilter: false,
      connectionFilter: null,
      count: 0,
      notification: ''
    };

    this.handleDateSubmit = this.handleDateSubmit.bind(this);
    this.notificationTimeout = null;
  }

  componentWillUnmount() {
    this.cancelNotification();
  }

  showNotification = (notification) => {
    this.cancelNotification();

    this.setState({ notification });

    this.notificationTimeout = setTimeout(this.hideNotification, 5000);
  };

  hideNotification = () => {
    this.cancelNotification();
    this.setState({ notification: '' });
  };

  cancelNotification = () => {
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
      this.notificationTimeout = null;
    }
  };

  getActiveFilterItems = (key) => {
    switch (key) {
      case 'Connection Status':
        const activeConnectionStatus = [];
        const rawConnectionStatus = this.props.filterBody.connectionState;
        if (rawConnectionStatus && rawConnectionStatus.includes('Connected')) activeConnectionStatus.push('Online');
        if (rawConnectionStatus && rawConnectionStatus.includes('Disconnected')) activeConnectionStatus.push('Offline');
        return activeConnectionStatus.length === 0 ? undefined : activeConnectionStatus;
      case 'Admin State':
        let activeAdminStates = [];
        const lockedStates = ['lock', 'locked'];
        const unlockedStates = ['unlocked', 'idle', 'running', 'unknown'];
        const rawAdminStates = this.props.filterBody['properties.reported.adminState'];
        if (rawAdminStates && lockedStates.every((state) => rawAdminStates.includes(state)))
          activeAdminStates.push('Locked');
        if (rawAdminStates && unlockedStates.every((state) => rawAdminStates.includes(state)))
          activeAdminStates.push('Unlocked');

        return activeAdminStates.length === 0 ? undefined : activeAdminStates;
      case 'Operational State':
        let activeOpStates = [];
        const rawOperationStates = this.props.filterBody['properties.reported.operationState'];
        if (rawOperationStates && rawOperationStates.includes('enabled')) activeOpStates.push('Enabled');
        if (rawOperationStates && rawOperationStates.includes('disabled')) activeOpStates.push('Disabled');

        return activeOpStates.length === 0 ? undefined : activeOpStates;
      case 'Device Type':
        let activeDeviceTypes = [];
        const rawDeviceTypes = this.props.filterBody['properties.reported.productType'];
        if (!rawDeviceTypes) return undefined;
        FILTER_DEVICE_TYPES.forEach((item) => {
          if (item.values.every((val) => rawDeviceTypes.includes(val))) activeDeviceTypes.push(item.type);
        });

        return activeDeviceTypes.length === 0 ? undefined : activeDeviceTypes;
      case 'Provisioned On':
        if (!this.props.filterBody['provisionTime']) return undefined;
        const dateRange =
          moment(this.props.filterBody['provisionTime'].from).format('M/D/YYYY') +
          ' - ' +
          moment(this.props.filterBody['provisionTime'].to).format('M/D/YYYY');

        return dateRange;
      case 'Alarms':
        const alarmOptions = ['critical', 'major', 'minor', 'warning'];
        let activeAlarms = [];
        alarmOptions.forEach((item) => {
          if (this.props.filterBody[`tags.fm-alarms.${item}`])
            activeAlarms.push(item.charAt(0).toUpperCase() + item.slice(1));
        });

        return activeAlarms.length === 0 ? undefined : activeAlarms;
      default:
        return;
    }
  };

  handleDateSubmit(start, end) {
    let filter = {
      provisionTime: {
        from: start ? start : 'ever',
        to: end ? end : 'now'
      }
    };
    this.props.addFilter(this.props.activeTab, filter);
    this.props.setDropModalOpen('Provisioned On', false);
  }

  handleDateClear = () => {
    this.props.handleRemoveFilter('provisionTime');
    // this.setState(this.clearDateState());
  };

  removeFilters = (filterSection) => {
    this.props.removeFilter(this.props.activeTab, filterSection);
  };

  handleActiveFilterOnClose = (key) => {
    switch (key) {
      case 'Connection Status':
        this.removeFilters('connectionState');
        break;
      case 'Admin State':
        this.removeFilters('properties.reported.adminState');
        break;
      case 'Operational State':
        this.removeFilters('properties.reported.operationState');
        break;
      case 'Device Type':
        this.removeFilters('properties.reported.productType');
        break;
      case 'Provisioned On':
        this.removeFilters('provisionTime');
        break;
      case 'Alarms':
        const options = ['critical', 'major', 'minor', 'warning'];
        const selectedOptions = [];
        options.forEach((item) => {
          if (this.props.filterBody[`tags.fm-alarms.${item}`] === true) {
            selectedOptions.push(item);
          }
        });
        const filterNameList = selectedOptions.map((filterName) => `tags.fm-alarms.${filterName}`);
        filterNameList.forEach((item) => this.removeFilters(item));
        break;
      default:
        return;
    }
  };

  canFilterSetUpdate = () => {
    if (!this.props.activeFilterSet) return false;

    const savedFilterSet = getParsedFilterSet(this.props.activeFilterSet.state);
    const activeFilters = JSON.parse(JSON.stringify(this.props.filterBody));

    // ignore the deviceId filter
    delete savedFilterSet['deviceId'];
    delete activeFilters['deviceId'];
    if (this.props.activeTab !== DEVICES_PAGE_TAB.all) {
      delete savedFilterSet['properties.reported.productType'];
      delete activeFilters['properties.reported.productType'];
    }

    return !areObjectsEqual(savedFilterSet, activeFilters);
  };

  onUpdateFilterSet = () => {
    const currFilterSet = this.props.activeFilterSet;
    const body = getFilterSetToSave(this.props.filterBody, this.props.activeTab === DEVICES_PAGE_TAB.all);

    this.props
      .patchUserPreference({
        preferenceId: currFilterSet.preferenceId,
        category: USER_PREFERENCE_SETS.FILTER_SET,
        state: body
      })
      .then(() => {
        this.props.addToastNotification({
          id: v4(),
          title: currFilterSet.name,
          description: 'successfully updated'
        });

        let filtersWithoutTypes = { ...this.props.filterBody };
        delete filtersWithoutTypes['properties.reported.productType'];
        const pivotFilters = { ...filtersWithoutTypes, ...DEFAULT_TAB_FILTER.pivot };
        const echoFilters = { ...filtersWithoutTypes, ...DEFAULT_TAB_FILTER.echo };
        const updateTabs = [DEVICES_PAGE_TAB.pivot, DEVICES_PAGE_TAB.echo, DEVICES_PAGE_TAB.all].filter(
          (tab) => tab !== this.props.activeTab
        );

        // update other 2 tabs with new requests
        updateTabs.forEach((tab) => {
          switch (tab) {
            case DEVICES_PAGE_TAB.pivot:
              this.props.parseAllSearchFilters(tab, pivotFilters, false, false);
              break;
            case DEVICES_PAGE_TAB.echo:
              this.props.parseAllSearchFilters(tab, echoFilters, false, false);
              break;
            case DEVICES_PAGE_TAB.all:
              this.props.parseAllSearchFilters(tab, filtersWithoutTypes, false, false);
              break;
            default:
              break;
          }
        });
      })
      .catch(() => {
        this.props.addToastNotification({
          id: v4(),
          title: currFilterSet.name,
          description: 'failed to update.'
        });
      });
  };

  updateDropModalState = (isOpen) => {
    this.props.setDropModalOpen('selectFilterSet', isOpen);
  };

  saveFilterSelectionOnClick = () => {
    this.updateDropModalState(false);

    this.props.updateDevicesPageCreateFilterModal(true);
  };

  selectFilterSetOnClick = (filter) => {
    this.updateDropModalState(false);
    if (filter) {
      this.props.updateActiveFilterPreference(filter.preferenceId);
      // do not trigger another search on initial load, initial device load is triggered from ConsolePage
      const activeFilterSet = this.props.filterPreferences.find(
        (pref) => pref.category === 'filter-set' && pref.preferenceId === filter.preferenceId
      );

      // parse filter set only, initial request sent from DevicesPage after devices groups are loaded
      if (activeFilterSet) {
        let activeFilters = getParsedFilterSet(activeFilterSet.state);
        let deviceIdFilter = this.props.filterBody?.deviceId;
        let newFilters = { ...activeFilters };

        if (deviceIdFilter) newFilters.deviceId = deviceIdFilter;

        this.props.parseAllSearchFilters(this.props.activeTab, newFilters, false, true);
      }
    } else {
      // No filters
      this.props.updateActiveFilterPreference('');
      let newFilters = {};
      let deviceIdFilter = this.props.filterBody?.deviceId;
      if (deviceIdFilter) newFilters = { deviceId: deviceIdFilter };
      this.props.parseAllSearchFilters(this.props.activeTab, newFilters, false, true);
    }
  };

  manageFiltersOnClick = () => {
    this.updateDropModalState(false);

    this.props.updateDevicesPageManageFilterModal(true);
  };

  render() {
    return (
      <div className={'FiltersBar'}>
        {this.props.manageFilterFilterSetModalOpen && <ManageFilterSetsModal />}
        {this.props.createFilterSetModalOpen && <CreateFilterSetModal notify={this.showNotification} />}
        <div className="FiltersBar_Filters_Div">
          <div className={'FiltersBar_MainFilters'}>
            <FilterSelectionDropdown
              filterPreferences={this.props.filterPreferences}
              filterPreferencesLoading={this.props.loading}
              manageFiltersOnClick={this.manageFiltersOnClick}
              saveFilterSelectionOnClick={this.saveFilterSelectionOnClick}
              selectFilterSetOnClick={this.selectFilterSetOnClick}
            />

            {this.state.notification && <FiltersBarNotification notification={this.state.notification} />}

            <FiltersBarSelectedFilter activeFilterSet={this.props.activeFilterSet} />

            <FiltersBarUpdateIcon
              canFilterSetUpdate={this.canFilterSetUpdate}
              onUpdateFilterSet={this.onUpdateFilterSet}
            />

            <FiltersBarFiltersContainer
              fetching={this.props.fetching}
              activeTab={this.props.activeTab}
              handleActiveFilterOnClose={this.handleActiveFilterOnClose}
              getActiveFilterItems={this.getActiveFilterItems}
              handleDateSubmit={this.handleDateSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

const selectPreferenceList = memoOnce(selectUserPreferenceList);

export default connect((store) => {
  let filterBody = {};

  const activeTab = store.ui.devicesPage.activeTab;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    filterBody = store.data.pivotFilterDictionary;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    filterBody = store.data.echoFilterDictionary;
  } else {
    filterBody = store.data.allDevicesFilterDictionary;
  }

  const userPreferences = selectUserPreferences(store);
  const filterPreferences = selectUserCategoryPreferences(userPreferences, USER_PREFERENCE_SETS.FILTER_SET);
  const filterPreferenceList = selectPreferenceList(userPreferences, USER_PREFERENCE_SETS.FILTER_SET);
  const activeFilterSetId = store.ui.devicesPage.activeFilterSetId;
  const activeFilterSet = selectUserPreference(userPreferences, activeFilterSetId);

  return {
    activeTab,
    filterBody,
    activeFilterSetId: store.ui.devicesPage.activeFilterSetId,
    activeFilterSet,
    filterPreferences: filterPreferenceList,
    loading: userPreferences.loading || filterPreferences.loading,
    createFilterSetModalOpen: store.ui.devicesPage.createFilterSetModal,
    manageFilterFilterSetModalOpen: store.ui.devicesPage.manageFilterSetsModal
  };
}, mapDispatchToProps)(FiltersBar);
